import { render } from "./Users.vue?vue&type=template&id=778a5603"
import script from "./Users.vue?vue&type=script&lang=js"
export * from "./Users.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/views/project/settings/Users.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "778a5603"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('778a5603', __exports__)) {
    api.reload('778a5603', __exports__)
  }
  
  module.hot.accept("./Users.vue?vue&type=template&id=778a5603", () => {
    api.rerender('778a5603', render)
  })

}


export default __exports__